/// <reference path="common.module.ts" />
module Meevo.Components.Common {

    declare let XLSX: any;
    declare let saveAs: Function;

    export enum FileTypeEnum {
        XLSX,
        XLS,
        CSV,
        TXT
    }

    export class DataExportService implements IDataExportService {

        generateFile(data: any, filename: string, type: FileTypeEnum): void {
            switch (type) {
                case FileTypeEnum.XLSX:
                    this.generateXLSX(data, filename);
                    break;
                case FileTypeEnum.XLS:
                    //
                    break;
                case FileTypeEnum.CSV:
                    this.generateCSV(data, filename);
                    break;
                case FileTypeEnum.TXT:
                    this.generateTXT(data, filename);
                    break;
            }
        }

        generateXLSX(ws: any, filename: string): void {
            _.defer(() => {
                const wsName: string = filename;
                let wb: any = { SheetNames: <string[]>[], Sheets: {} };

                wb.SheetNames.push(wsName);
                wb.Sheets[wsName] = ws;
                let wopts: any = { bookType: 'xlsx', bookSST: false, type: 'binary' };
                let wbout: string = XLSX.write(wb, wopts);
                saveAs(new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }), filename + ".xlsx")
            });
        }

        generateCSV(data: any, filename: string): void {
            _.defer(() => {
                saveAs(new Blob([data], { type: 'text/csv;charset=utf-8;' }), filename + ".csv");
            });
        }

        public generateTXT(data: any, filename: string): void {
            _.defer(() => {
                saveAs(new Blob([data], { type: 'text/plain;charset=utf-8;' }), filename + '.txt');
            });
        }

        private s2ab(s: string): ArrayBuffer {
            let buf: ArrayBuffer = new ArrayBuffer(s.length);
            let view: Uint8Array = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }

        /**
         * It creates a csv file out of list of flat objects
         * @param rows      : Array of flat objects
         * @param filename  : Instead of 'data.csv'
         * @param header    : Header instead of object properties names
         */
        static exportToCsv(rows: object[], filename = 'data.csv', header?: string[], customKeys?: string[]) {
            if (!rows || !rows.length) {
                return;
            }
            const separator = ',';
            const title = this.buildHeader(header, Object.keys(rows[0])) || Object.keys(rows[0]);
            const keys = customKeys || Object.keys(rows[0]);
            const csvData =
                title.join(separator) +
                '\n' +
                rows.map(row => {
                    return keys.map(k => {
                        let cell = row[k] === null || row[k] === undefined ? '' : row[k];
                        cell = cell instanceof Date
                            ? cell.toLocaleString()
                            : cell.toString().replace(/"/g, '""');
                        if (cell.search(/("|,|\n)/g) >= 0) {
                            cell = `"${cell}"`;
                        }
                        return cell;
                    }).join(separator);
                }).join('\n');

            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                const link = document.createElement('a');
                if (link.download !== undefined) {
                    // Browsers that support HTML5 download attribute
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        }

        private static buildHeader(list: string[] = [], keys : string[]) {
            const idx = list.indexOf(null);
            if (idx < 0) {
                return list
            }
            list[idx] = keys[idx];

            return this.buildHeader(list, keys)

        }

        private static merge(objects: any[]) {
            var out = {};
            for (var i = 0; i < objects.length; i++) {
                for (var p in objects[i]) {
                    out[p] = objects[i][p];
                }
            }
            return out;
        }

        private static flatten(obj: object, key?: string | number, stem?: string | number, props?: string[] ) {
            let out = {};
            const newStem = (typeof stem !== 'undefined' && stem !== '') ? stem + '-' + key : key;

            if (typeof obj !== 'object') {
                out[newStem] = obj;
                return out;
            }
            let isArray = Array.isArray(obj);

            for (let k in obj) {
                let found = !!props ? props.indexOf(k) > -1 : true;
                if (isArray || found) {
                    let key = isArray ? +k + 1 : k
                    const prop = this.flatten(obj[k], key, newStem, props);
                    out = this.merge([out, prop]);
                }
            }
            return out;
        };
        /**
         * It flattens an object to a list of props
         * @param data  the object to be flatten
         * @param sources props that data is 
         * * @param props data to extract
         */
        static flatObject(data: object, sources: string[], props: string[]): object {
            if (!data) {
                return;
            }
            var flat = this.flatten(data, undefined, undefined, sources);

            const result = {};
            props.forEach(key => {
                if (flat.hasOwnProperty(key)) {
                    result[key] = flat[key];
                    delete flat[key];
                }
            });

            return result;
        }

        static factory(): Function {
            let svc = () => {
                return new DataExportService();
            }
            return svc;
        }

    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.DataExportService", DataExportService.factory());
}